import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';

const serverUrl = publishObjectPath.serverUrl;

export class SiteManagementServer {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 作业票
  // 分页查询所有数据
  public getSiteManagementList(opts: object) {
    const url = serverUrl + '/api/yunnan/workTicket';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 通过主键查询单条数据详情
  public getSingleSiteManagementData(id: any) {
    const url = serverUrl + `/api/yunnan/workTicket/${id}`;
    return this.rSerivce.serverObj.get(url);
  }

  // 删除 作业票数据
  public deleteSiteManagementList(idList: any) {
    if (idList instanceof Array) {
      idList = idList.join(',');
    }
    const url = serverUrl + '/api/yunnan/workTicket?idList=' + idList;
    return this.rSerivce.serverObj.delete(url, {
      params: idList,
    });
  }

  public getWorkTicketConfigAll(opts: object) {
    const url = serverUrl + '/api/yunnan/workTicketConfig/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  public getCustomizeFlowFormId(opts: object) {
    const url = serverUrl + '/api/yunnan/workTicket/flow/getCustomizeFlowFormId';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  public getLockingControl(opts: object) {
    const url = serverUrl + '/api/yunnan/workTicket/flow/getLockingControl';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 新增流程
  public addFlowForm(opts: object, type: any) {
    const url = serverUrl + '/api/yunnan/workTicket/flow/insertForm?type=' + type;
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 修改流程
  public editFlowForm(opts: object, id: any) {
    const url = serverUrl + '/api/yunnan/workTicket/flow/updateFlowForm/' + id;
    return this.rSerivce.serverObj.put(url, opts);
  }
  //  作业票状态
  public getWorkTicketStatusGroup() {
    const url = serverUrl + '/api/yunnan/workTicket/status/group';
    return this.rSerivce.serverObj.get(url);
  }
}
